import { render, staticRenderFns } from "./carportWarnPanel.vue?vue&type=template&id=2a0c8418&"
import script from "./carportWarnPanel.vue?vue&type=script&lang=js&"
export * from "./carportWarnPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports